const foldouts = [...document.querySelectorAll('.c-header__foldout')].map(
  foldout => ({
    id: foldout.id,
    foldout,
    links: [...foldout.querySelectorAll('a')],
    sections: [...foldout.querySelectorAll('.c-header__foldout-sections > li')].map(
      section => ({
        section,
        links: [...section.querySelectorAll('a')],
      }),
    )
  }),
);

// --- Keyboard navigation stuff ---

const findNext = (item, foldout, key) => {
  const index = foldout.links.indexOf(item);
  const section = foldout.sections.findIndex(section => section.links.includes(item));

  // Moving between sections
  if (section >= 0 && key === 'ArrowLeft') {
    const newSection = Math.max(section - 1, 0);
    return foldout.sections[newSection]?.links[0];
  }
  if (section < foldout.sections.length && key === 'ArrowRight') {
    const newSection = Math.min(section + 1, foldout.sections.length - 1);
    return foldout.sections[newSection]?.links[0];
  }

  // Moving up and down
  const deltas = {
    ArrowUp: -1,
    ArrowDown: 1,
    Home: -foldout.links.length,
    End: foldout.links.length,
  };
  if (index === -1 || !deltas[key]) {
    return undefined;
  }
  const newIndex = Math.min(Math.max(index + deltas[key], 0), foldout.links.length - 1);
  return foldout.links[newIndex];
};

const handleItemKey = foldout => event => {
  if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
    return;
  }
  const link = event.currentTarget;

  // Special case: pressing up on the first item move focus back to the foldout trigger
  if (link === foldout.links[0] && event.key === 'ArrowUp') {
    const trigger = document.querySelector(`[aria-controls='${foldout.id}']`);
    if (trigger) {
      trigger.focus();
      event.preventDefault();
      return;
    }
  }

  // Move the focus around by left/right/up/down/home/end keys
  const next = findNext(link, foldout, event.key);
  if (next) {
    next.focus();
    event.preventDefault();
  }
};

// --- Setup ---

foldouts.forEach(foldout => {
  for (const link of foldout.links) {
    link.addEventListener('keydown', handleItemKey(foldout));
  }
});
